import { Extension } from '@tiptap/core';
import { MinimalMediaTarget } from 'Shared/FrameModules/MediaLibrary/minimal_target';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      mediaManager: {
         activateMediaManager: () => ReturnType;
      };
   }
}

export const MediaManager = Extension.create({
   name: 'mediaManager',

   addCommands() {
      return {
         activateMediaManager:
            () =>
            ({ commands }) => {
               commands.blur();
               const editor = this.editor;

               const target = new MinimalMediaTarget({
                  customAttach: (mediaItem: any, finished: any) => {
                     if (mediaItem) {
                        const imageContent = mediaItem.toWikiText();
                        editor.chain().focus().insertContent(imageContent).run();
                     }
                     // Finished expects the old media item in the case of mutation
                     // and a success boolean.
                     finished(null, true);
                  },
                  accepts: 'wiki_media',
               });

               (window as any).MediaManager.browse(target);

               return true;
            },
      };
   },
});
